import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";

const ComboSiNo = ({
  value,
  onChange,
  name,
  error = false,
  helperText = null,
  fullWidth = false,
  disabled = false,
  required = false,
  label,
}) => {
  return (
    <FormControl
      variant="outlined"
      size="small"
      error={error}
      disabled={disabled}
      fullWidth={fullWidth}
      required={required}
    >
      <InputLabel id={`${name}Label`}>{label}</InputLabel>
      <Select
        labelId={`${name}Label`}
        id={name}
        name={name}
        label={`${label}${required ? "*" : ""}`}
        value={value}
        onChange={(e) => onChange(e)}
      >
        <MenuItem value="S">SI</MenuItem>
        <MenuItem value="N">NO</MenuItem>
      </Select>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
};

export default ComboSiNo;
